<template>
  <div v-if="versionObj" class="my-2 flex justify-center px-2">
    <a target="_blank" v-if="!versionObj.upToDate" :href="monitorLink">
      <UiChip color="warning">
        <UiIcon name="fa-circle-exclamation" class="mr-2 -ml-1.5" />
        Mettre à jour {{ versionObj.version }}</UiChip
      >
    </a>
    <UiChip color="success" v-else>
      <UiIcon name="fa-check-circle" class="mr-2 -ml-1.5" />{{
        versionObj.version
      }}</UiChip
    >
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue'

import UiChip from '@/shared/components/ui/UiChip.vue'
import UiIcon from '@/shared/components/ui/UiIcon.vue'

import { useSessionStore } from '../store/session.store'

const sessionStore = useSessionStore()
const versionObj = computed(() => sessionStore.version)
const isAdmin = computed(
  () => sessionStore.principal?.roles.includes('admin') ?? false,
)

onMounted(async () => {
  if (isAdmin.value && !versionObj.value) {
    await useSessionStore.getState().checkVersion()
  }
})

const env = window.location.host.includes('.chapi.to')
  ? window.location.host.substring(0, window.location.host.indexOf('.chapi.to'))
  : 'itg'

const monitorLink = `https://itg-chapito-monitor.c-t.io/?display=list&search=${env}`
</script>
